import { Component } from '@angular/core';

@Component({
    templateUrl: './notfound.component.html',
    standalone: false
})
export class NotFoundComponent {}
